<template>
    <div class="content">
        <Row type="flex" align="middle" class="code-row-bg mb16">
            <Col span="24">
                <Breadcrumb>
                    <Breadcrumb-item to="/">首页</Breadcrumb-item>
                    <Breadcrumb-item to="/my/customizedLineWork/rider">我的保全</Breadcrumb-item>
                    <Breadcrumb-item>保全详情</Breadcrumb-item>
                </Breadcrumb>
            </Col>
        </Row>
        <riderBasicInfo class="mb16" :info="info" title="批单基本信息" type="rider" />
        <supportPlans :info="info" type="rider" />
    </div>
    </template>
    <script>
    import riderBasicInfo from '../common/riderBasicInfo'
    import supportPlans from '../common/supportPlans'
    export default {
        components:{
            riderBasicInfo,
            supportPlans
        },
        data () {
            return {
                info:{},
                id:this.$route.params.id,
                loading:false,
            }
        },
        mounted () {
            this.getInfo();
        },
        methods:{
            /*企业雇主责任险获取批单信息*/
            getInfo () {
                this.$axios.post('/casual/insurance/change/user.json.dst',{
                    billNo: this.id
                }).then(res=>{
                    this.info = res;
                });
            },
        }
    }
    </script>
<style lang="less" scoped>
    .content{
        width: 100%;
        height: 100%;
        padding: 15px;
        box-sizing: border-box;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedLineWork/rider/detail.vue